// extracted by mini-css-extract-plugin
export default {"root":"CollaboratorsButton_root__eVREX"};